import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  state: () => ({
    currentUser: null,
    fetchingUserData: false,
    userProfile: {
      user: false,
      emails: [],
      collaborators: [],
      handles: {},
      profile: {},
      active: null,
      lastWorkspaceId: null
    }
  }),
  getters,
  mutations,
  actions
};
